import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { Button } from '@material-ui/core'
import * as actions from '../actions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_PERFIL } from '../../../config/forms'
import isEmail from 'validator/lib/isEmail'
import CamposPerfil from './CamposPerfil'

function DialogoPerfil (props) {
  const [isValidEmail, setIsValidEmail] = useState(true)
  const [isValidEmailNotificaciones, setIsValidEmailNotificaciones] = useState(true)

  useEffect(() => {
    const {
      rolDeCupo,
      username,
      change: formChange
    } = props

    props.buscarInfoUser(username, formChange)
    if (rolDeCupo.length > 0) {
      console.log('Rol de cupo detectado en LoginInfo', rolDeCupo)
      if (rolDeCupo[0] === 'CARGADOR') {
        console.log('Redirigiendo a cargador...')
        props.buscarCorreoCargador(username, formChange)
      } else if (rolDeCupo[0] === 'CORREDOR') {
        console.log('Redirigiendo a corredor...')
        props.buscarCorreoCorredor(username, formChange)
      }
    }
  }, [])

  const {
    handleClose,
    handleSubmit,
    username
  } = props

  const handleChangeEmail = event => {
    const val = event.target.value
    if (isEmail(val)) {
      setIsValidEmail(true)
    } else {
      setIsValidEmail(false)
    }
  }

  const handleChangeEmailNotificaciones = event => {
    const val = event.target.value
    if (isEmail(val)) {
      setIsValidEmailNotificaciones(true)
    } else if (val === '') {
      setIsValidEmailNotificaciones(true)
    } else {
      setIsValidEmailNotificaciones(false)
    }
  }

  return (
    <div>
      <Card style={{ border: 'none' }}>
        <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
          <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Perfil de {username}</Card.Text>
        </Card.Header>
        <Card.Body>
          <div>
            <CamposPerfil
              handleChangeEmail={handleChangeEmail}
              handleChangeEmailNotificaciones={handleChangeEmailNotificaciones}
              rolDeCupo={props.rolDeCupo}
            />
          </div>
        </Card.Body>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            style={{ margin: '2%' }}
            onClick={handleClose}
            size='medium'
            variant='contained'
            color='primary'
          >Cancelar</Button>
          {(isValidEmail && isValidEmailNotificaciones)
            ? <Button
              style={{ margin: '2%' }}
              size='medium'
              variant='contained'
              color='primary'
              onClick={handleSubmit}
            >Guardar</Button>
            : <Button
              style={{ margin: '2%' }}
              size='medium'
              variant='contained'
              color='primary'
              disabled
            >Guardar</Button>
          }
        </div>
      </Card>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    username: state.auth.username
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PERFIL,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: true,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoPerfil))
